import { render, staticRenderFns } from "./Mase.vue?vue&type=template&id=4890c410&"
import script from "./Mase.vue?vue&type=script&lang=js&"
export * from "./Mase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports